<div class="p-d-flex p-flex-column p-jc-center p-jc-md-center">
    <div class="p-grid p-m-auto p-col-12">
        <p-card styleClass="p-card-shadow" class="p-mb-2 p-col-12">
            <form class="p-m-2" name="sugerenciaForm" #sugerenciaForm="ngForm">
                <div class="p-grid">
                    <h2 class="p-col-12">{{'RECLAMACIONES.TITULO' | translate}}</h2>
                    <h5 class="p-col-8">{{'GLOBAL.INTRODUCIR.DATOS' | translate}}</h5>
                    <div class="p-col-12 p-md-12 p-mb-2">
                        <b><label for="contrasenaAntigua">{{'GLOBAL.EMAIL.CONTACTO' | translate}}</label></b> <br>
                        <input #emailInput="ngModel" id="emailInput" class="w-100" type="text" pInputText [(ngModel)]="email" name="emailInput" required (input)="validateEmail()" />
                        <small *ngIf="(emailInput.dirty && emailInput.invalid) " class="p-invalid">{{'REGISTRO.EMAIL.OBLIGATORIO' |translate}}</small>
                        <small *ngIf="(mensajeErrorEmail)" class="p-invalid">{{'REGISTRO.ERROR.EMAIL' |translate}}</small>
                    </div>
                    <div class="p-col-12 p-md-12 p-mb-2">
                        <b><label for="descripcionSugerencia">{{'RECLAMACIONES.DESCRIPCION' | translate}}</label></b><br>
                        <textarea id="descripcionSugerencia" class="w-100" [rows]="10" [cols]="100" pInputTextarea autoResize="autoResize" type="text" [(ngModel)]="sugerencia.descripcion" [placeholder]="'RECLAMACIONES.DESCRIPCION.OBLIGATORIA' | translate" name="descripcionSugerencia"
                            required></textarea>
                    </div>
                    <div class="p-col-12 p-d-flex p-jc-center p-jc-md-center">
                        <p-button class="pr-2 pl-2 pb-1 pt-1 " p-pButton [label]=" 'GLOBAL.ENVIAR' | translate " icon="fas fa-paper-plane" type="submit " [disabled]="(sugerenciaForm.form.invalid || mensajeErrorEmail) " (click)="enviar()"></p-button>
                    </div>
                </div>
            </form>
        </p-card>
    </div>
</div>

<dum-toast #dumToast></dum-toast>
